import AdminLayout from "@/components/AdminLayout";
import { Construction } from "lucide-react";

/**
 * Generic "Coming Soon" placeholder for routes booked in Phase 7
 * but built out in later phases (10, 11, 12, 13).
 */
export default function Placeholder({ title, breadcrumbs = [], phase = "" }) {
  return (
    <AdminLayout title={title} breadcrumbs={breadcrumbs.length ? breadcrumbs : ["Home", title]}>
      <div className="bg-white rounded-lg shadow border border-slate-200 p-16 text-center" data-testid="placeholder-page">
        <Construction className="h-12 w-12 mx-auto text-amber-500 mb-4" />
        <h2 className="text-xl font-semibold text-slate-800 mb-2">{title}</h2>
        <p className="text-slate-500 text-sm max-w-md mx-auto">
          This module is on the roadmap{phase ? ` and is planned for Phase ${phase}` : ""}.
          The route is live so navigation works end-to-end — the data view will follow soon.
        </p>
      </div>
    </AdminLayout>
  );
}
